import { Form } from "@circle-react-shared/uikit/Form";
import { DEFAULT_UNITS } from "./constants";

interface TypographySliderControlProps {
  label: string;
  max?: number;
  min?: number;
  name: string;
  step?: number;
}

export const TypographySliderControl = ({
  name,
  label,
  min = 0,
  max = 100,
  step = 0.1,
}: TypographySliderControlProps) => (
  <Form.Item hideBorder hideDescription name={name} label={label}>
    <Form.SliderWithInput
      name={name}
      min={min}
      max={max}
      step={step}
      units={DEFAULT_UNITS}
    />
  </Form.Item>
);
